<template>
    <span>
        <el-select v-model="selectValue"  :placeholder="placeholder" :clearable="clearable" :multiple="multiple" :disabled="disabled">
        <el-option
                v-for="item in selectDict"
                :key="item.dictValue"
                :label="item.name"
                :value="item.dictValue">
        </el-option>
    </el-select>
        <input v-model="value" style="display: none" />
    </span>
</template>

<script>
    export default {
        name: "DictSelect",
        props:{
            placeholder:{
              type:String,
              default:function () {
                  return '请选择';
              }
            },
            value: {
                type: String,
                default:function () {
                    return '' ;
                }
            },
            clearable: {
                type: Boolean,
                default:function () {
                    return false ;
                }
            },disabled: {
                type: Boolean,
                default:function () {
                    return false ;
                }
            },
            multiple : {
                type: Boolean,
                default:function () {
                    return false ;
                }
            },
            typeFlag:{
                type: String,
                default:''
            }
        },
        watch:{
            value:{
              deep:true,
              handler:function () {
                  this.selectValue = this.value;
              }
            },
            selectValue:{
                deep:true,
                handler:function () {
                    this.$emit('input',this.selectValue);
                    this.$emit('change',this.selectValue);
                    this.$emit('changeObject',this.selectDict ? this.selectDict.find((r)=>{return r.dictValue === this.selectValue }):null);
                }
            }
        },
        computed:{
            selectDict(){

                let vm = this;
                let dict = this.dict.find((r)=>{return r.flag === vm.typeFlag });

                if(dict){
                    return dict.dictItems;
                }else{
                    return dict;
                }


            }
        },
        data(){
            return {
                dict:[],
                selectValue:[],
            }
        },
        created() {

            let vm = this;

            vm.selectValue = vm.value;


            if(!window.dictPromise){
                window.dictPromise = new Promise((res)=>{
                    vm.$http.post(vm.$api.dictType.allDict).then((resp)=>{
                        res(resp)
                    });
                })
            }

            window.dictPromise.then((resp)=>{
                vm.dict = resp.data.data.dictTypes;
            })





        }
    }
</script>

<style scoped>

</style>
